

export class CityOutputWithStatus implements ICityOutputWithStatus {
    /** The auto-generated id of the city master */
    city_id!: number;
    /** The city name with 255 character limit */
    city_name!: string;
    /** Manage status of city. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: ICityOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city_id = _data["city_id"];
            this.city_name = _data["city_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CityOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new CityOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city_id"] = this.city_id;
        data["city_name"] = this.city_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface ICityOutputWithStatus {
    /** The auto-generated id of the city master */
    city_id: number;
    /** The city name with 255 character limit */
    city_name: string;
    /** Manage status of city. 0 For De-active, 1 For Active */
    status: number;
}

